class NewsletterButtonController {
    /*@ngInject*/
    constructor($log, $rootScope, CommonService) {
        $log.debug('NewsletterButtonController initialized');
        this.$log = $log;
        this.isSubscribed = null;
        this.commonService = CommonService;

        $rootScope.$on('personalizeRequestSuccess', () => {
            this.isSubscribed = this.commonService.getPersonalizeRequestResponse().hasFashionNewsletter;
        });

    }
}

export default NewsletterButtonController;
